import React from 'react';
import { fmtPct, signed } from '../shared/format';

function varianceCell(line) {
  if (!line) return <span className="text-gray-500">—</span>;
  const tone = line.variance < 0 ? 'text-red-700' : 'text-green-700';
  return (
    <span className={`font-semibold ${tone}`}>
      {signed(line.variance)} <span className="font-normal text-gray-600">(target {line.target})</span>
    </span>
  );
}

/** Team total row plus one row per salesperson; a name filters the report to that person. */
const SalespersonTable = ({ rows, team, onSelect }) => (
  <div className="bg-white rounded-2xl shadow-md overflow-x-auto">
    <table className="w-full min-w-[920px] border-collapse text-sm">
      <thead>
        <tr className="bg-slate-100 text-left text-gray-700">
          <th className="px-5 py-3.5 font-semibold">Salesperson</th>
          <th className="px-4 py-3.5 font-semibold">Follow-ups done / due</th>
          <th className="px-4 py-3.5 font-semibold">Completion</th>
          <th className="px-4 py-3.5 font-semibold">vs target</th>
          <th className="px-4 py-3.5 font-semibold">Site visits taken / scheduled</th>
          <th className="px-4 py-3.5 font-semibold">Closed Won</th>
          <th className="px-4 py-3.5 font-semibold">Pending calls</th>
          <th className="px-5 py-3.5 font-semibold">Overdue calls</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.userId ?? 'unassigned'} className="border-t border-gray-200">
            <td className="px-5 py-3.5 font-semibold">
              {row.userId ? (
                <button
                  type="button"
                  onClick={() => onSelect(row.userId)}
                  className="text-[#1F4B55] underline text-left min-h-[32px]"
                >
                  {row.name}
                </button>
              ) : (
                <span className="text-gray-600">{row.name}</span>
              )}
            </td>
            <td className="px-4 py-3.5">
              {row.leads.followUpsCompleted} / {row.leads.followUpsScheduled}
            </td>
            <td className="px-4 py-3.5">{fmtPct(row.leads.followUpCompletionPct)}</td>
            <td className="px-4 py-3.5">{varianceCell(row.targets?.followUps)}</td>
            <td className="px-4 py-3.5">
              {row.leads.siteVisitsTaken} / {row.leads.siteVisitsScheduled}
            </td>
            <td className="px-4 py-3.5">{row.leads.closedWon}</td>
            <td className="px-4 py-3.5">{row.preLeads.pendingCalls}</td>
            <td
              className={`px-5 py-3.5 font-semibold ${
                row.preLeads.overdueCalls > 0 ? 'text-red-700' : 'text-green-700'
              }`}
            >
              {row.preLeads.overdueCalls}
            </td>
          </tr>
        ))}
        <tr className="border-t-2 border-[#1F4B55] bg-slate-50 font-bold">
          <td className="px-5 py-3.5">Team total</td>
          <td className="px-4 py-3.5">
            {team.leads.followUpsCompleted} / {team.leads.followUpsScheduled}
          </td>
          <td className="px-4 py-3.5">{fmtPct(team.leads.followUpCompletionPct)}</td>
          <td className="px-4 py-3.5">{varianceCell(team.targets?.followUps)}</td>
          <td className="px-4 py-3.5">
            {team.leads.siteVisitsTaken} / {team.leads.siteVisitsScheduled}
          </td>
          <td className="px-4 py-3.5">{team.leads.closedWon}</td>
          <td className="px-4 py-3.5">{team.preLeads.pendingCalls}</td>
          <td className={`px-5 py-3.5 ${team.preLeads.overdueCalls > 0 ? 'text-red-700' : 'text-green-700'}`}>
            {team.preLeads.overdueCalls}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default SalespersonTable;
